module.exports = __webpack_public_path__ + "img/hc_login_1.c66edcbf.png";